import { createContext } from 'react';

const fichaContext = createContext();

export default fichaContext;
